import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {AppService} from '@irb/app.service';
import { Subscription } from 'rxjs';
import {IEvent, IrbAppEvents, IrbDialogsEvents, IrbEditorsEvents, IrbModelsEvents} from '@irb-common/events';
import {SecurityMasterService} from '@irb/irb-models/security-master/security-master.service';
import {IDropdownItem} from '@irb-common/models/dropdown.model';
import {IrbEditorsService} from '@irb/irb-editors/irb-editors.service';
import {
    ICompSecurityDto,
    ICompSecurityGridItem,
    ISecurityModelAllocation,
    ISecurityModelHistory
} from '@irb/irb-editors/irb-editors.model';
import {UtilityService} from '@irb-common/services/utility.service';
import {Router} from '@angular/router';
import {IRebalResponseObject} from '@irb/irb-rebalance/results/results.model';
import {ComponentSecuritiesGridLayoutService} from '@irb/irb-editors/editor-security/component-securities/component-securities.grid-layout.service';
import {CalltoactionService} from '@irb-common/components/calltoaction/calltoaction.service';
import {ISecurity} from '@irb/irb-models/irb-models.model';
import {WINDOW} from '@irb/app.tokens';
import {IAlertDialogData} from '@irb/app.model';

@Component({ standalone: false,
    selector: 'irb-component-securities',
    templateUrl: './component-securities.component.html',
    styleUrls: ['./component-securities.component.scss']
})

export class ComponentSecuritiesComponent implements OnInit, OnDestroy {

    @ViewChild('securitiesDropdown') securitiesDropdown: any;

    _componentSecuritiesData: any;
    private saveCompSecurityDtoSet: Array<ICompSecurityDto> = [];
    private deletedSecIdList: Array<ICompSecurityGridItem> = [];
    private eventSubscription: Subscription;
    securitiesList: any[];
    private grid: any;
    gridData: Array<ICompSecurityGridItem>;
    private gridDataTracker: Array<ICompSecurityGridItem>;
    gridOptions: any;
    private invalidTypesForGroupSecurity: string[] = ["SMA", "EXTERNAL", "GROUP"];
    private tempDeletedSecurities: number[] = [];
    private allComponentSecuritiesData: any;
    isUiTest = false;
    updateStatusCount = 0;
    progressTimer: any = null;
    frameworkComponents: any;

    @Output()
    groupSecurityChanged: EventEmitter<Array<ICompSecurityDto>> = new EventEmitter<Array<ICompSecurityDto>>();
    @Output()
    deletedSecIdListChanged: EventEmitter<Array<ICompSecurityGridItem>> = new EventEmitter<Array<ICompSecurityGridItem>>();

    rowCount: number = 0;

    @Input()
    set componentSecuritiesData(value: { multipleSecurity: boolean, isModelSecurity: boolean, securityData: any[] }) {
        this.rowCount = 0;
        this.tempDeletedSecurities = [];
        this.saveCompSecurityDtoSet = [];
        this.deletedSecIdList = [];
        this.gridDataTracker = [];
        this.gridData = null;
        this.allComponentSecuritiesData = null;
        this._componentSecuritiesData = value.securityData[0];
        this.loadInitialData();
    }

    constructor(
        private as: AppService,
        private securityMasterService: SecurityMasterService,
        private ies: IrbEditorsService,
        private util: UtilityService,
        private router: Router,
        private csgls: ComponentSecuritiesGridLayoutService,
        private ctas: CalltoactionService,
        @Inject(WINDOW) public window: Window,
    ) {

        this.gridOptions = {
            columnDefs: this.csgls.getColumnDefs(this),            
            floatingFilter: false,
            overlayNoRowsTemplate:
                "<span class='ag-overlay-loadGriding-center ag-overlay-message'>No Component Security Data</span>",
            context: {componentParent: this},
        };
        
        this.frameworkComponents = this.csgls.getFrameworkComponents();
    }

    ngOnInit(): void {
        this.eventSubscription = this.as.getEvents().subscribe((s) => {
            this.processEvent(s);
        });
    }
    ngOnDestroy(): void {
        if (this.eventSubscription) {
            this.eventSubscription.unsubscribe();
        }
    }

    private loadInitialData() {
        this.getInitialGridData();
        this.getComponentSecuritiesDropdownData();
    }

    onGridReady(params: any) {
        this.grid = params;
        this.loadGrid();
    }

    getInitialGridData() {
        this.ies.getGroupComponentSecurities(this._componentSecuritiesData.securityId).subscribe((res: any) => {
            this.gridDataTracker = res;
            this.loadGrid();
        });
    }

    private processEvent(event: IEvent) {
        switch (event.type) {
            case IrbModelsEvents.SAVE_MASTER_MULTIPLE_SECURITY:
                if (event.data && event.data.type === 'editSecurities') {
                    const selectedSecurities = event.data.selectedSecurities;
                    const securityIdArray: number[] = [];
                    const securitySymbolsArr: any = [];
                    selectedSecurities.forEach((security: any) => {
                        if (security.securityId) {
                            securityIdArray.push(security.securityId);
                            securitySymbolsArr.push(security.securitySymbol);
                        }
                    });
                    // this.checkSecurity(selectedSecurities,securitySymbolsArr,securityIdArray);
                    this.ValidateSecuritiesSelected(selectedSecurities);
                }
                break;
            case IrbModelsEvents.SAVE_CREATE_NEW_SECURITY:
                if (event.data && event.data.editSecurity === true) {
                    let newData = event.data;
                    if (newData.editComponentSecurities
                        && newData.securities
                        && newData.securities.responseData
                        && newData.securities.responseData.length !== 0) {
                       this.ValidateSecuritiesSelected(newData.securities.responseData);
                    }
                    // this.addNewlyCreatedSecurityToGrid(event.data);
                }
                break;
        }
    }

    ValidateSecuritiesSelected(selectedSecurities: any[]) {
        let groupSecurityArray: any[] = [];
        let externalSecurityArray: any[] = [];
        let hasCashSecurity = false;
        let smaSecurityArray: any[] = [];
        let processedArray: any[] = [];

        if (selectedSecurities && selectedSecurities.length > 0) {
            hasCashSecurity = false;
            selectedSecurities.forEach((security: any) => {
                if (security.securitySymbol === '$CASH') {
                    hasCashSecurity = true;
                } else {
                    if (security.securityType === 'GROUP') {
                        groupSecurityArray.push(security);
                    } else if (security.securityType === 'SMA') {
                        smaSecurityArray.push(security);
                    } else if (security.securityType === 'EXTERNAL') {
                        externalSecurityArray.push(security);
                    } else {
                        processedArray.push(security);
                    }
                }
            });
        }

        let dialogData = {
            securitiesWarningsData: {
                currentGroupSecurity: this._componentSecuritiesData,
                hasCashSecurity: hasCashSecurity,
                responseData: selectedSecurities,
                groupSecurities: groupSecurityArray,
                smaSecurities: smaSecurityArray,
                externalSecurities: externalSecurityArray,
                processArray: processedArray
            },
            continueFunction: this.reviewSecuritiesData.bind(this)
        };
        this.as.fireEvent(IrbEditorsEvents.SHOW_MOVE_SECURITIES_WARNINGS_DIALOG, dialogData);
    }

    reviewSecuritiesData(securityWarningsData: any) {
        // console.log('securityWarningsData on Continue in Component Securities', securityWarningsData);
        if (securityWarningsData && securityWarningsData.responseData && securityWarningsData.responseData.length > 1) {
            // show Multiple Securities with Grid Display of data.
            let dialogData = {
                securitiesWarningsData: securityWarningsData,
                continueFunction: this.checkSecurityUsage.bind(this)
            };
            this.as.fireEvent(IrbEditorsEvents.SHOW_MOVE_SECURITIES_GRID_DATA_DIALOG, dialogData);
        } else {
            // Call Check Securitiy Usage method.
            this.checkSecurityUsage(securityWarningsData);
        }
    }

    checkSecurityUsage(securityWarningsData: any) {
        // console.log('Check Security Usage Method', securityWarningsData);
        let dialogData = {
            securitiesWarningsData: securityWarningsData,
            continueFunction: this.loadOnSecurityUsageReviewComplete.bind(this)
        };
        this.as.fireEvent(IrbEditorsEvents.SHOW_MOVE_SECURITIES_USAGE_REVIEW_DIALOG, dialogData);
    }

    loadOnSecurityUsageReviewComplete(securityWarningsData: any) {
        // console.log('loadOnSecurityUsageReviewComplete', securityWarningsData);
        if (securityWarningsData && securityWarningsData.processArray && securityWarningsData.processArray.length > 0) {
            let securityIds: any[] = [];
            securityWarningsData.processArray.forEach((security:any)=>{
                securityIds.push(security.securityId);
            });
            this.addSecurityToGrid(securityIds);
        }
    }

    checkSecurity(selectedSecurities: any, securitySymbolsArr: any, securityIdArray: any) {
        if (selectedSecurities.length === 1) {
            selectedSecurities.forEach((security: any) => {
                if (security.securityType === 'SMA') {
                    let altMsg = '<div class="bold block">' + security.securitySymbol + ' selected</div>';
                    altMsg += '<br><div class="bold"></div> ' + security.securitySymbol + ' is a SMA Security, and cannot be moved into another GroupSecurity.';
                    this.showWarningforSecurity(altMsg);
                } else if (security.securityType === 'GROUP') {
                    let altMsg = '<div class="bold block">' + security.securitySymbol + ' selected</div>';
                    altMsg += '<br><div class="bold"></div> ' + security.securitySymbol + ' is a Group Security, and cannot be moved into another GroupSecurity.';
                    this.showWarningforSecurity(altMsg);
                } else if (security.securityType === 'EXTERNAL') {
                    let altMsg = '<div class="bold block">' + security.securitySymbol + ' selected</div>';
                    altMsg += '<br><div class="bold"></div> ' + security.securitySymbol + ' is a External Security, and cannot be moved into another GroupSecurity.';
                    this.showWarningforSecurity(altMsg);
                } else if (security.securityType === 'CASH') {
                    let altMsg = '<div class="bold block">' + security.securitySymbol + ' selected</div>';
                    altMsg += '<br><div class="bold"></div> ' + security.securitySymbol + ' cannot be moved.';
                    this.showWarningforSecurity(altMsg);
                } else {
                    let altMsg = '<div class="bold block">' + security.securitySymbol + ' selected</div>';
                    altMsg += '<br><div class="bold"></div>iRebal will review the selected security to see if it is in use elsewhere in the application before being moved.<br><br>Click "continue" to begin the review.';
                    this.showWarningforSecurity(altMsg);
                }
            });
        } else {
            const altMsg = '<div class="bold block">' + securitySymbolsArr + ' selected</div>iRebal will review the selected security to see if it is in use elsewhere in the application before being moved.<br><Click "continue" to begin the review.';
            this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
                dTitle: 'Move Security into a Group',
                dType: 'INFO',
                altMsgHTML: altMsg,
                dCancelBtnLabel: "Cancel",
                dProceedBtnLabel: "Continue",
                onProceed: (() => {
                    this.checkMoveSecurityReviewDialog(securityIdArray, securitySymbolsArr);
                })
            } as IAlertDialogData);
        }


    }

    showWarningforSecurity(altMsg: any, security?: any) {
        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
            dTitle: 'Move Security into a Group',
            dType: 'INFO',
            altMsgHTML: altMsg,
            dCancelBtnLabel: "Cancel",
            dProceedBtnLabel: "Continue",
            onProceed: (() => {
                this.checkSecurityAdditionalRestrictions(true, security.securityId);
            })
        } as IAlertDialogData);
    }

    checkMoveSecurityReviewDialog(securityIdArray: number[], securitySymbolsArr: Array<string>) {
        let altMsg = '<div class="bold block">' + securitySymbolsArr + ' selected</div>iRebal is ready to move the selected security into the group security specified below.Note: This security will no longer be listed in the security master.';
        altMsg += '<br><br><div class="bold">Move selection into: "' + this._componentSecuritiesData.securitySymbol + '"</div>';
        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
            dTitle: 'Move Security into a Group',
            altMsgHTML: altMsg,
            dType: 'INFO',
            dCancelBtnLabel: "Cancel",
            dProceedBtnLabel: "Proceed. Move the selected security",
            onProceed: (() => {
                this.checkSecurityAdditionalRestrictions(true, securityIdArray);

            })
        } as IAlertDialogData);

    }

    checkSecurityAdditionalRestrictions(move: boolean, securityIdArray: number[]) {
        this.securityMasterService.getDetailsBeforeMoveOrDeleteAsync(securityIdArray).subscribe(
            (res: IRebalResponseObject) => {
                if (res.responseUtilityMap) {
                    this.getDetailsBeforeMoveOrDeleteCheckIntervalStart(res.responseUtilityMap.statusId, move, securityIdArray);
                }
            });
    }
    updateProgressBarStatus(response: any, move: boolean, securityIdArray: number[]) {
        let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
        if (this.isUiTest)
            timeout = 0;
        this.updateStatusCount++;
        this.progressTimer = setTimeout(() => {
            this.getDetailsBeforeMoveOrDeleteCheckIntervalStart(response.statusId, move, securityIdArray);
        }, timeout);
    }
    getDetailsBeforeMoveOrDeleteCheckIntervalStart(statusId: any,move: boolean, securityIdArray: number[]) {
        this.securityMasterService.getDetailsBeforeMoveOrDeleteStatusCheck(statusId).subscribe((statusResponse: any) => {
            if (statusResponse.responseStatus === "SUCCESS") {
                const response = statusResponse?.responseUtilityMap;
                const reqStatus = response?.reqStatus?.trim().toUpperCase();
                if (reqStatus === 'FAILED') {
                    this.actionStatusCheckFailed();
                }

                if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
                    this.updateProgressBarStatus(response, move, securityIdArray);
                }
                if (reqStatus === 'COMPLETED') {
                    this.processResponse(statusResponse, move, securityIdArray);
                }
            } else {
                this.progressTimer && clearTimeout(this.progressTimer);
            }
        }, () => {
            this.progressTimer && clearTimeout(this.progressTimer);
        });
    }
    actionStatusCheckFailed() {
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dType: 'ERROR',
            dTitle: '',
            dProceedBtnLabel: '',
            msg: 'An error occurred processing your request.',
            onProceed: () => {
            }
        } as IAlertDialogData);
    }
    processResponse(res: IRebalResponseObject,move: boolean, securityIdArray: number[] ) {
        const records = res?.responseUtilityMap?.records;
        if (res.responseStatus !== 'SUCCESS' || records?.reqStatus === 'FAILED' || records?.affectedSecurities > 0) {
            this.handleAddSecuritiesExceptions(res, securityIdArray, move);
        } else if (res.responseData && (records?.securitiesAffected > 0 || records?.affectedPortfolios > 0)) {
            const csd = {
                data: {
                    securityIdArray: securityIdArray,
                    response: res,
                },
                continueToAddSecuritiesToGrid: (() => {
                    this.addSecurityToGrid(securityIdArray);
                }).bind(this)
            };
            this.as.fireEvent(IrbDialogsEvents.SHOW_SECURITY_USAGE_WARNING, csd);
        } else {
            this.addSecurityToGrid(securityIdArray);
        }
    }
    handleAddSecuritiesExceptions(res: IRebalResponseObject, securityIdArray: number[], move: boolean) {
        const actionType = move ? "move" : "delete";
        const callBackData = {
            res: res,
            securityIdArray: securityIdArray,
            actionType: actionType
        };
        const records = res?.responseUtilityMap?.records;
        // user is attempting to add multiple securities
        if (securityIdArray.length > 1 && records?.affectedSecurities > 0) {
            const numberOfAffectedSecs = records?.affectedSecurities;
            const totalNumberOfSecs = securityIdArray.length;
            this.showToast('error',
                'ERROR: Could not move security into a group',
                numberOfAffectedSecs + ' of ' + totalNumberOfSecs + ' SECURITIES CANNOT be moved. You cannot move securities ' +
                'when they are being used as an SMA, or as a target in a model, or as a target security in a scheduled rebalance or as an ' +
                'external security.You should first edit the security, model, or scheduled rebalance so that the security can be moved. ' +
                'Click view details for more information.', "View Details", '', callBackData);
        } else {
            //user is using the single security input box
            if (records?.secWithModels) {
                const securityModelDetailsArr = records?.modelDetails[securityIdArray[0]];
                this.showToast('error',
                    'ERROR: Could not move security into a group',
                    securityModelDetailsArr[0].securitySymb
                    + ' cannot be added to a group security because it is being used in '
                    + records?.affectedModel + ' models.', "View Details", '', callBackData);
            } else if (records?.secWithRebalances) {
                const securityRebalanceDetailsArr = records?.rebalanceDetails[securityIdArray[0]];
                this.showToast('error',
                    'ERROR: Could not move security into a group',
                    securityRebalanceDetailsArr[0].securitySymb
                    + ' cannot be added to a group security because it is being used as a target security in '
                    + records?.affectedRebalances + 'rebalances', 'View Details', '', callBackData);
            } else if (records?.secWithAccounts) {
                const securityAccountDetailsArr = records?.accountDetails[securityIdArray[0]];
                this.showToast('error',
                    'ERROR: Could not move security into a group',
                    securityAccountDetailsArr[0].securitySymb
                    + ' cannot be added to a group security because it is being used in '
                    + records?.affectedAccounts + 'accounts', 'View Details', '', callBackData);
            } else {
                this.showToast('error', 'Alert',
                    'An error occurred while processing your request.', '', '');
            }
        }
    }

    addNewlyCreatedSecurityToGrid(newData: any) {
        if (newData.editComponentSecurities && newData.securities && newData.securities.responseData && newData.securities.responseData.length !== 0) {
            let validGroupSecurityCreated: boolean = true;
            let invalidSecurity: any = null;
            const securityIdArray: number[] = [];
            newData.securities.responseData.forEach((item: any) => {
                if (this.invalidTypesForGroupSecurity.indexOf(item.securityType) > -1) {
                    validGroupSecurityCreated = false;
                    invalidSecurity = item;
                } else {
                    if (item.securityType !== 'OPTION') {
                        securityIdArray.push(item.securityId);
                    }
                }
            });
            if (validGroupSecurityCreated) {
                this.addSecurityToGrid(securityIdArray);
            } else {
                this.handleCreateSecurityExceptions(invalidSecurity);
            }
        }
    }

    handleCreateSecurityExceptions(item: any) {
        let securitySymbol = '';
        if (item && item.securitySymbol) {
            securitySymbol = item.securitySymbol;
            if (item.securityType.toUpperCase() === 'SMA') {
                this.showToast('error',
                    'ERROR: Could not move security into a group',
                    securitySymbol + ' cannot be added to a group security because it is an SMA security.',
                    "", '');
            } else if (item.securityType.toUpperCase() === 'GROUP') {
                this.showToast('error',
                    'ERROR: Could not move security into a group',
                    securitySymbol + ' cannot be added to a group security because it is a group security.',
                    "", '');
            } else if (item.securityType.toUpperCase() === 'EXTERNAL') {
                this.showToast('error',
                    'ERROR: Could not move security into a group',
                    securitySymbol + ' cannot be added to a group security because it is an External security.',
                    "", '');
            } else {
                this.showToast('error', 'Alert',
                    'An error occurred while processing your request.', '', '');
            }
        } else {
            this.showToast('error', 'Alert',
                'An error occurred while processing your request.', '', '');
        }
    }

    viewDetails(actionType: string, idsArr: number[], response: IRebalResponseObject) {
        if (response !== undefined && response.responseStatus === "SUCCESS") {
            // console.log("checkpoint 1 replaced");
            const modelsArr: any = [], accountsArr: any = [], rebalancesArr: any = [], externalSecArr: any = [];
            const records = response?.responseUtilityMap?.records;
            idsArr.forEach((entry) => {
                if (records?.modelDetails && records?.modelDetails[entry]) {
                    records?.modelDetails[entry].forEach((item: any) => {
                        modelsArr.push(item);
                    });
                }

                if (records?.accountDetails && records?.accountDetails[entry]) {
                    records?.accountDetails[entry].forEach((item: any) => {
                        accountsArr.push(item);
                    });
                }

                if (records?.rebalanceDetails && records?.rebalanceDetails[entry]) {
                    records?.rebalanceDetails[entry].forEach((item: any) => {
                        rebalancesArr.push(item);
                    });
                }
                // need this?
                if (records?.extSecDetails && records?.extSecDetails[entry]) {
                    records?.extSecDetails[entry].forEach((item: any) => {
                        externalSecArr.push(item);
                    });
                }
            });

            // underlay.hide();

            let openWindowContent = '', affectedModel = records?.affectedModel;
            let affectedAccounts = records?.affectedAccounts;
            let affectedRebalances = records?.affectedRebalances;
            let affectedSecurities = records?.affectedSecurities;
            let secWithModels = records?.secWithModels;
            let secWithAccounts = records?.secWithAccounts;
            let secWithRebalances = records?.secWithRebalances;
            let externalSec = records?.externalSecurities;
            openWindowContent += '<link type="text/css" rel="stylesheet" href="/irebal/resources/css/viewDetails.css"/>';
            openWindowContent += '<h1>' + ((actionType === "delete") ? "Deletion" : "Move") + '&nbsp;Refusal Detail</h1>';
            openWindowContent += '<div style="margin-top:10px;">' + ((actionType === "delete") ? "Deletion" : "Movement") + '&nbsp;of&nbsp;' +
                ((affectedSecurities > 1) ? 'securities' : 'security') + '&nbsp;in iRebal cannot be completed due to the following conditions:</div>';
            //msg = openWindowContent;
            //openWindowContent = "";
            if (modelsArr.length > 0) {
                openWindowContent += '<div style="margin-top:30px;"><i><b>' + ((secWithModels > 1) ? 'These selected securities cannot be&nbsp;' : 'This selected security cannot be&nbsp;') +
                    ((actionType == "delete") ? "deleted" : "moved") + '&nbsp;because&nbsp;' + ((secWithModels > 1) ? '&nbsp;they<br/>are' : '&nbsp;it<br/>is') +
                    '&nbsp;targeted in the models as noted:</b></i></div>';
                openWindowContent += '<div style="margin-top:20px;" class="overlayTable">';
                modelsArr.forEach((entry: any) => {
                    openWindowContent += '<div style="width:100%;height:20px;"><span style="width:100px;"><b>' + entry.securitySymb + '</b></span>';
                    openWindowContent += '<span style="width:190px;">has a&nbsp;<i>Target%</i>&nbsp;of&nbsp;' + entry.targetPerc + '% in</span>';
                    openWindowContent += '<span style="width:150px;">' + entry.modelName + '</span>';
                    openWindowContent += '<span style="width:244px;">' + ((entry.modelDesc && entry.modelDesc != null) ? entry.modelDesc : "") + '</span></div>';
                });
                openWindowContent += '</div><div style="margin-top:20px;">To&nbsp;' + ((actionType === "delete") ? "delete" : "move");
                if (secWithModels > 1) {
                    openWindowContent += '&nbsp;any of these securities, you must edit&nbsp;' + ((affectedModel > 1) ? 'any models' : 'model') + '&nbsp;in which they are targeted, and un-target&nbsp;' + ((affectedModel > 1) ? 'them' : 'it') + '.</div>';
                } else {
                    openWindowContent += '&nbsp;this security, you must edit&nbsp;' + ((affectedModel > 1) ? 'any models' : 'model') + '&nbsp;in which it is targeted, and un-target&nbsp;' + ((affectedModel > 1) ? 'them' : 'it') + '.</div>';
                }
            }
            if (accountsArr.length > 0) {
                openWindowContent += '<div style="margin-top:30px;"><i><b>' + ((secWithAccounts > 1) ? 'These selected securities cannot be&nbsp;' : 'This selected security cannot be&nbsp;') +
                    ((actionType === "delete") ? "deleted" : "moved") + '&nbsp;because&nbsp;' + ((secWithAccounts > 1) ? 'they<br/>are' : 'it<br/>is') +
                    '&nbsp;specified as SMA symbols for the accounts as noted:</b></i></div>';
                openWindowContent += '<div style="margin-top:20px;" class="overlayTable">';
                accountsArr.forEach((entry: any) => {
                    openWindowContent += '<div style="width:100%;height:20px;"><span style="width:100px;"><b>' + entry.securitySymb + '</b></span>';
                    openWindowContent += '<span style="width:220px;">is the SMA Security for account:</span>';
                    openWindowContent += '<span style="width:100px;">' + entry.accountNumber + '</span>';
                    openWindowContent += '<span style="width:350px;">' + entry.accountName + '</span></div>';

                });
                openWindowContent += '</div><div style="margin-top:20px;">To&nbsp;' + ((actionType === "delete") ? "delete" : "move");
                if (secWithAccounts > 1) {
                    openWindowContent += '&nbsp;any of these securities, you must edit the SMA&nbsp;' + ((affectedAccounts > 1) ? 'accounts' : 'account') +
                        ', and un-specify&nbsp;' + ((affectedAccounts > 1) ? 'them' : 'it') + 'as the SMA security.</div>';
                } else {
                    openWindowContent += '&nbsp;any of this security, you must edit the SMA&nbsp;' + ((affectedAccounts > 1) ? 'accounts' : 'account') +
                        ', and un-specify&nbsp;' + ((affectedAccounts > 1) ? 'them' : 'it') + '&nbsp;as the SMA security.</div>';
                }
            }
            if (rebalancesArr.length > 0) {
                openWindowContent += '<div style="margin-top:30px;"><i><b>' + ((secWithRebalances > 1) ? 'These selected securities cannot be&nbsp;' : 'This selected security cannot be&nbsp;') +
                    ((actionType === "delete") ? "deleted" : "moved") + '&nbsp;because&nbsp;' + ((secWithRebalances > 1) ? '&nbsp;they<br/>are' : '&nbsp;it<br/>is') +
                    '&nbsp;being used in the scheduled rebalances listed below:</b></i></div>';
                openWindowContent += '<div style="margin-top:20px;" class="overlayTable">';
                rebalancesArr.forEach((entry: any) => {
                    openWindowContent += '<div style="width:100%;height:20px;"><span style="width:100px;"><b>' + entry.securitySymb + '</b></span>';
                    openWindowContent += '<span style="width:250px;">is being used in the scheduled rebalance:</span>';
                    openWindowContent += '<span style="width:250px;">' + entry.rebalanceName + '</span>';
                    openWindowContent += '<span style="width:150px;">' + entry.analysisCreatedBy + '</span></div>';
                });
                openWindowContent += '</div><div style="margin-top:20px;">To&nbsp;' + ((actionType === "delete") ? "delete" : "move");
                if (secWithRebalances > 1) {
                    openWindowContent += '&nbsp;any of these securities, you must remove either delete the scheduled&nbsp;' +
                        ((affectedRebalances > 1) ? 'rebalances' : 'rebalance') + '&nbsp;listed above, or remove these securities from&nbsp;' +
                        ((affectedRebalances > 1) ? 'them.' : 'it.') + '</div>';
                } else {
                    openWindowContent += '&nbsp;this security, you must either delete the scheduled ' +
                        ((affectedRebalances > 1) ? 'rebalances' : 'rebalance') + '&nbsp;listed above, or remove this security from&nbsp;' +
                        ((affectedRebalances > 1) ? 'them.' : 'it.') + '</div>';
                }
            }
            if (externalSecArr.length > 0) {
                openWindowContent += '<div style="margin-top:30px;"><i><b>' + ((externalSec > 1) ? 'These selected securities cannot be&nbsp;' : 'This selected security cannot be&nbsp;') +
                    ((actionType == "delete") ? "deleted" : "moved") + '&nbsp;because&nbsp;' + ((externalSec > 1) ? '&nbsp;they<br/>are' : '&nbsp;it<br/>is') +
                    '&nbsp;an external security:</b></i></div>';
                openWindowContent += '<div style="margin-top:20px;" class="overlayTable">';
                externalSecArr.forEach((entry: any) => {
                    openWindowContent += '<div style="width:100%;height:20px;"><span style="width:100px;"><b>' + entry + '</b></span></div>';
                });
                openWindowContent += '</div><div style="margin-top:20px;">Consider removing the external ' + ((externalSec > 1) ? 'securities' : 'security') + ' from the account and replacing with the group security.</div>';

            }
            const openWindow = this.window.open("", "_blank");
            if (openWindow && openWindow.document) {
                const doc = openWindow.document;
                const bodyElements = doc.getElementsByTagName('body');
                const bodyElement = bodyElements[0];
                const fragment = doc.createRange().createContextualFragment(openWindowContent);
                bodyElement.appendChild(fragment);
            }
        }
    }

    showToast(severity: string, summary: string, detailedMessage: string, linkText: string, navigationPath: string, callBackData?: any) {
        if (navigationPath != null && navigationPath.length > 0) {
            this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
        }
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            key: 'irb-embedded-link-toast',
            severity: severity,
            summary: summary,
            detail: detailedMessage,
            sticky: false,
            closable: true,
            linkText: linkText,
            life: 5000,
            callBack: (() => {
                this.as.fireEvent(IrbAppEvents.HIDE_TOAST);
                if (callBackData) {
                    const res = callBackData.res;
                    const secIdArr = callBackData.securityIdArray;
                    const actionType = callBackData.actionType;
                    this.viewDetails(actionType, secIdArr, res);
                }
            })
        });
    }

    getComponentSecuritiesDropdownData() {
        this.ies.getAllSecuritiesForGroupComponent(this._componentSecuritiesData.securityId).subscribe((res: any) => {
            this.allComponentSecuritiesData = res.items;
        });
    }

    getFilteredListOfSecurities(searchStr: string) {
        if (!searchStr || (searchStr && searchStr.trim() === '')) {
            this.securitiesDropdown.set([]);
            return;
        }
        if (this.allComponentSecuritiesData) {
            const sortByKey = this.util.sortByKey;
            const filteredSecurities: Array<any> = this.allComponentSecuritiesData.filter((item: any) => {
                return item.securitySymbol.toLowerCase().indexOf(searchStr.toLowerCase()) !== -1 &&
                    this.tempDeletedSecurities.indexOf(item.securityId) === -1;
            });
            let item: any;
            const securityFieldsForDropDown: any = [];
            filteredSecurities.forEach((security: any) => {
                item = {
                    name: security.securitySymbol,
                    value: security.securityId
                };
                securityFieldsForDropDown.push(item);
            });
            sortByKey(securityFieldsForDropDown, "name", "asc");
            if (this.securitiesDropdown) {
                this.securitiesDropdown.set(securityFieldsForDropDown);
            }
        }
        return;
    }

    onSecuritiesChange(s: Array<IDropdownItem>) {
        this.securitiesList = s;
    }

    addSecurityToGrid(securityIdArray: number[]) {
        const sa: number[] = []; // newly added security ids
        let deletedIsBack: boolean = false;

        securityIdArray.forEach((newSecurityId) => {
            let isExisting: boolean = false;
            this.gridDataTracker.forEach((security) => {
                if (newSecurityId === security.securityId) {
                    isExisting = true;
                    if (security.action === 'delete') {
                        // if security was previously deleted from grid, but not saved
                        security.action = null;
                        deletedIsBack = true;
                        this.adjustCompSecDTO(security);
                    } else {
                        // security is in the grid currently or will be added
                        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                            severity: "warn",
                            summary: "",
                            detail: "Security(ies) cannot be listed twice.",
                        });
                    }
                }
            });
            if (!isExisting) {
                // security was never there.
                sa.push(newSecurityId);
            }
        });

        // if a previously deleted sec was added back.
        if (sa.length === 0 && deletedIsBack) {
            this.loadGrid();
            this.groupSecurityChanged.emit(this.saveCompSecurityDtoSet);
        }

        if (sa.length > 0) {
            this.ies.getSecuritieAllocations(sa).subscribe((data: ISecurity[]) => {
                if (!this.containsInvalidSecurityTypeForGroup(data)) {
                    let newSecurityItem: ICompSecurityGridItem;
                    for (const item of data) {
                        newSecurityItem = this.setItemsBasedOnSymbIDToGrid(item);
                        this.gridDataTracker.push(newSecurityItem);
                        this.adjustCompSecDTO(newSecurityItem);
                    }
                    this.loadGrid();
                    this.groupSecurityChanged.emit(this.saveCompSecurityDtoSet);
                }
            });
        }
        this.securitiesDropdown.clear();
    }

    containsInvalidSecurityTypeForGroup(data: ISecurity[]) {
        let invalidSecurityTypeAdded = false;
        let invalidSecurity;
        for (const item of data) {
            if (item.securityType) {
                if (this.invalidTypesForGroupSecurity.indexOf(item.securityType) > -1) {
                    invalidSecurityTypeAdded = true;
                    invalidSecurity = item;
                    break;
                }
            }
        }
        if (invalidSecurityTypeAdded) {
            this.handleCreateSecurityExceptions(invalidSecurity);
        }
        return invalidSecurityTypeAdded;
    }

    addSecuritiesFromDropdown() {
        const securityIds: number[] = [];
        if (this.securitiesList.length > 0) {
            this.securitiesList.forEach((security) => {
                if (security.value) {
                    securityIds.push(security.value);
                }
            });
            // this.checkSecurityAdditionalRestrictions(true, securityIds);
            this.ies.getSecuritieAllocations(securityIds).subscribe((data: ISecurity[]) => {
               this.ValidateSecuritiesSelected(data);
            });
        }
    }

    adjustCompSecDTO(item: ICompSecurityGridItem) {
        if (item.action === 'ADD') {
            const newCompSecItem: ICompSecurityDto = {
                securityId: this._componentSecuritiesData.securityId,
                isUIdeleted: "false",
                gcsCompSecId: item.securityId
            };
            this.saveCompSecurityDtoSet.push(newCompSecItem);
        } else if (item.action === 'DELETE') {
            const newCompSecItem: ICompSecurityDto = {
                securityId: this._componentSecuritiesData.securityId,
                isUIdeleted: "true",
                gcsCompSecId: item.securityId
            };
            this.saveCompSecurityDtoSet.push(newCompSecItem);
        } else {
            this.saveCompSecurityDtoSet.forEach((security, index) => {
                if (security.gcsCompSecId === item.securityId) {
                    this.saveCompSecurityDtoSet.splice(index, 1);
                }
            });
        }
    }

    addToDeletedSecIdList(item: ICompSecurityGridItem) {
        if (item.securityId) {
            this.deletedSecIdList.push(item);
            this.tempDeletedSecurities.push(item.securityId);
        }
    }

    setItemsBasedOnSymbIDToGrid(item: ISecurity): ICompSecurityGridItem {
        const newSecurityItem: ICompSecurityGridItem = {
            securitySymbol: item.securitySymbol || null,
            securityDescription: item.securityDescription || null,
            securityType: item.securityType || null,
            securityId: item.securityId,
            versionId: item.versionId,
            action: 'ADD'
        };
        return newSecurityItem;
    }

    onCreateNewSecurity() {
        const dataParam: any = {
            editSecurity: true,
            editComponentSecurities: true
        };
        this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_SECURITIES, dataParam);
    }

    showAddMultipleSecuritiesDialog() {
        let dataInputForMultipleSelection: any = [];
        this.grid.api.forEachNode(function (node: any) {
            dataInputForMultipleSelection.push(node.data);

        });
        const params = {
            type: 'editSecurities',
            data: dataInputForMultipleSelection
        };
        this.as.fireEvent(IrbModelsEvents.SHOW_MASTER_MULTIPLE_SECURITY, params);
    }

    loadGrid() {
        if (this.grid && this.grid.api && this.gridDataTracker) {
            this.gridData = this.gridDataTracker.filter((x) => {
                return x.action !== "DELETE";
            });
            this.grid.api.setGridOption('rowData', this.gridData);
            this.rowCount = this.getRowCount();
        }
    }

    extractAll() {
        if (this.gridDataTracker.length > 0) {
            let index = this.gridDataTracker.length - 1;
            for (index; index >= 0; index--) {
                const item = this.gridDataTracker[index];
                if (this.gridDataTracker[index].action === 'ADD') {
                    this.gridDataTracker.splice(index, 1);
                    item.action = null;
                } else {
                    this.gridDataTracker[index].action = 'DELETE';
                    item.action = 'DELETE';
                }
                this.adjustCompSecDTO(item);
            }
            this.loadGrid();
            this.groupSecurityChanged.emit(this.saveCompSecurityDtoSet);
        }
    }

    extract(cc: ICompSecurityGridItem) {
        const deletedItem: ICompSecurityGridItem = this.removeFromGrid(cc);
        this.adjustCompSecDTO(deletedItem);
        this.loadGrid();
        this.groupSecurityChanged.emit(this.saveCompSecurityDtoSet);
    }

    deleteAll() {
        this.ctas.remove();
        const deletedSecList = this.getAllGridSecurities();
        if (deletedSecList && deletedSecList.length > 0) {
            this.as.fireEvent(IrbDialogsEvents.SHOW_DELETE_COMPONENT_SECURITIES_DIALOG, {
                securityDeletedIds: deletedSecList,
                deleteContinueFunction: this.deleteAllContinueCallback.bind(this)
            });
        }
    }

    deleteAllContinueCallback() {
        if (this.gridDataTracker.length > 0) {
            let index = this.gridDataTracker.length - 1;
            for (index; index >= 0; index--) {
                const item = this.gridDataTracker[index];
                if (this.gridDataTracker[index].action === 'ADD') {
                    this.gridDataTracker.splice(index, 1);
                    item.action = null;
                } else {
                    this.gridDataTracker[index].action = 'DELETE';
                    item.action = 'DELETE';
                }
                this.adjustCompSecDTO(item);
                this.addToDeletedSecIdList(item);
            }
            this.loadGrid();
            this.groupSecurityChanged.emit(this.saveCompSecurityDtoSet);
            this.deletedSecIdListChanged.emit(this.deletedSecIdList);
        }
    }

    getAllGridSecurities(): Array<ICompSecurityGridItem> {
        const gridSecuritiesList: Array<ICompSecurityGridItem> = [];
        if (this.gridDataTracker.length > 0) {
            let index = this.gridDataTracker.length - 1;
            for (index; index >= 0; index--) {
                gridSecuritiesList.push(this.gridDataTracker[index]);
            }
        }
        return gridSecuritiesList;
    }

    delete(cc: ICompSecurityGridItem) {
        this.ctas.remove();
        this.as.fireEvent(IrbDialogsEvents.SHOW_DELETE_COMPONENT_SECURITIES_DIALOG, {
            securityDeletedIds: [cc] as Array<ICompSecurityGridItem>,
            deleteContinueFunction: this.deleteContinueCallback.bind(this)
        });
    }

    deleteContinueCallback(data: Array<ICompSecurityGridItem>) {
        if (data.length === 1) {
            const item: ICompSecurityGridItem = data[0];
            const deletedItem: ICompSecurityGridItem = this.removeFromGrid(item);
            this.adjustCompSecDTO(deletedItem);
            this.addToDeletedSecIdList(deletedItem);
            this.loadGrid();
            this.groupSecurityChanged.emit(this.saveCompSecurityDtoSet);
            this.deletedSecIdListChanged.emit(this.deletedSecIdList);
        }
    }

    removeFromGrid(item: ICompSecurityGridItem): ICompSecurityGridItem {
        if (this.gridDataTracker.length > 0) {
            let index = this.gridDataTracker.length - 1;
            for (index; index >= 0; index--) {
                const gridItem = this.gridDataTracker[index];
                if (gridItem.securityId === item.securityId) {
                    if (gridItem.action === 'ADD') {
                        this.gridDataTracker.splice(index, 1);
                        item.action = null;
                    } else {
                        this.gridDataTracker[index].action = 'DELETE';
                        item.action = 'DELETE';
                    }
                }
            }
        }
        return item;
    }

    getRowCount() {
        return this.gridData ? this.gridData.length : 0;
    }

    cancelDelete() {
        this.ctas.remove();
    }

    isValid() {
        return true;
    }

}
